import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';
import { IEICFTemplate, IEICFTemplateInput } from '../EICFTemplate.ts';

interface UpdateVars {
    id: number;
    input: IEICFTemplateInput;
}

export function usePutEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<IEICFTemplate, AppMedError, UpdateVars>({
        mutationKey: [QueryKeys.eicfTemplates, 'update'],
        mutationFn: ({ id, input }) => EICFTemplatesApi.put(id, input),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplates] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplate, vars.id] });
        },
    });
}
